import { AutoMap } from "@automapper/classes";
import { Contract } from "./contract";

export class Client {

    @AutoMap()
    Code!: string
    @AutoMap()
    Name!: string
    @AutoMap()
    Address!: string
    @AutoMap()
    City!: string
    @AutoMap()
    ZipCode!: string
    @AutoMap()
    ContractList: Contract[] = [];
    @AutoMap()
    ElimsClientCode: string = '';

}
